import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WhatIsSection } from './components/WhatIsSection';
import { BridgesSection } from './components/BridgesSection';
import { LivableBooksSection } from './components/LivableBooksSection';
import { KnoogetsSection } from './components/KnoogetsSection';
import { EngineSection } from './components/EngineSection';
import { AudienceSection } from './components/AudienceSection';
import { UseCasesSection } from './components/UseCasesSection';
import { PhilosophySection } from './components/PhilosophySection';
import { FooterCTA } from './components/FooterCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WhatIsSection data-id="element-4" />
        <BridgesSection data-id="element-5" />
        <LivableBooksSection data-id="element-6" />
        <KnoogetsSection data-id="element-7" />
        <EngineSection data-id="element-8" />
        <AudienceSection data-id="element-9" />
        <UseCasesSection data-id="element-10" />
        <PhilosophySection data-id="element-11" />
        <FooterCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}